import styled from 'styled-components';
import { rem } from 'polished';
import { cssHelpers } from '@luigiclaudio/ga-baseline-ui/helpers';

const ColorNameLabel = styled.span`
    display: block;
    max-width: ${rem(170)};
    ${cssHelpers.textOverflow}
`;

export default ColorNameLabel;
